import { render, staticRenderFns } from "./addDealCRMNotes.vue?vue&type=template&id=79058b6e"
import script from "./addDealCRMNotes.vue?vue&type=script&lang=js"
export * from "./addDealCRMNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports